<script lang="ts">
import {stationStore } from "../../../store";
const { showStartAndEnd, getSelectedStation } = stationStore; 
//getSchedule()

</script>

<div id="radio-top-schedule">
    <div class="container">
      <div class="row">
        <div class="col-6 my-2 my-lg-3">
          <div class="schedule-caption"><span class="colored">Na sporedu</span> {$showStartAndEnd.currentShowStart} - {$showStartAndEnd.currentShowEnd} </div>
          <div class="schedule-title h4 shownameshort" title="{$getSelectedStation.onair.current.vsebina}">{$getSelectedStation.onair.current.vsebina}</div>
        </div>
        <div class="col-6 my-2 my-lg-3 schedule-delimiter">
          <div class="schedule-caption"><span class="colored">Sledi</span> {$showStartAndEnd.nextShowStart} - {$showStartAndEnd.nextShowEnd} </div>
          <div class="schedule-title h4 shownameshort" title="{$getSelectedStation.onair.next.vsebina}">{$getSelectedStation.onair.next.vsebina}</div>
        </div>
        <!--<div class="col-4 my-2 my-lg-3 schedule-delimiter d-flex align-items-center">
          <a href="/spored" class="schedule-title h4"><span class="icon-calendar colored mr-2"></span>Spored</a>
        </div>-->
      </div>
    </div>
  </div>